import { cn } from '@/lib/utils'
import { Label } from '@/ui/Shadcn/label'
import { Textarea as TextareaShadcn } from '@/ui/Shadcn/textarea'
import { memo } from 'react'

export function Textarea({
  label,
  className,
  id,
  required,
  ...props
}: React.ComponentProps<typeof TextareaShadcn> & {
  label?: string
  className?: string
  id?: string
  required?: boolean
}) {
  return (
    <div className={cn(`relative flex flex-col`, className)}>
      {label && (
        <Label
          htmlFor={id}
          className="top-md left-md absolute text-neutral-600"
        >
          {label} {required && '*'}
        </Label>
      )}
      <textarea
        id={id}
        className={cn(
          'px-md pb-xs pt-lg basic-input input-focus textstyle-md-regular placeholder:text-neutral-400',
          className
        )}
        rows={props.rows || 6}
        {...props}
      />
    </div>
  )
}

export default memo(Textarea)
